import React from "react";
import { Button } from "semantic-ui-react";
import SemanticUiModal from "../modal";

const ToolTipVideoModal = ({ open, title, videoSrc, onClose }) => {
  if (!open) return null;

  const matches = videoSrc.match(/\/(\d+)(?!.*\/\d+)/);
  const videoId = matches ? matches[1] : null;

  return (
    <SemanticUiModal
      modalOptions={{ size: "large", closeOnDimmerClick: false }}
      header={`Video - ${title}`}
      content={
        videoId ? (
          <div className="video-container">
            <iframe
              key={videoId}
              src={`https://player.vimeo.com/video/${videoId}`}
              allow="autoplay; fullscreen"
              allowFullScreen
              title={title}
            />
          </div>
        ) : (
          <p>No video available</p>
        )
      }
      actions={
        <Button onClick={onClose} primary>
          Close
        </Button>
      }
      closeModal={onClose}
    />
  );
};

export default ToolTipVideoModal;


// WEBPACK FOOTER //
// ./src/components/tool_tips/tool_tip_video_modal.js